import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Breadcrumbs Panel"})
export default class BreadcrumbsPanelConfig {

	@Input({type: InputType.NUMBER_POSITIVE, title: "Min Visible Items"})
	public minItems: number = 0;

	@Input({type: InputType.CHECKBOX, title: "Show Only Back"})
	public showOnlyBack: boolean;

	@Input({ type: InputType.TEXT, title: "Back Label" })
	public label: string = 'Back';
}



// WEBPACK FOOTER //
// ./src/panels/breadcrumbs/BreadcrumbsPanelConfig.ts